import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import { AnalyticsMode } from '@core/analytics-types';

export enum ShareCandidatesAnalyticsTrigger {
  Share = 'share',
  EvaluationRequest = 'evaluationRequest',
  ScheduleInterview = 'scheduleInterview',
}

@Injectable({ providedIn: 'root' })
export class ShareCandidatesAnalytics extends AnalyticsBase {
  public readonly namespace = 'ShareCandidates';
  public readonly requireViewContext = false;

  public trackAddTeamMembers({
    teamMembers,
    trigger,
    mode,
    candidates = 1,
  }: {
    teamMembers: number;
    trigger: ShareCandidatesAnalyticsTrigger;
    mode: AnalyticsMode;
    candidates?: number;
  }): void {
    this.track(
      'AddTeamMembers',
      { teamMembers, trigger, mode, candidates },
      { integrations: { All: false, Mixpanel: true, Intercom: true } },
    );
  }

  public trackRemoveTeamMember(): void {
    this.track('RemoveTeamMember');
  }
}
